import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { OMDefaultsLayout } from "../../common/Layouts";
let transportCarrier = null;
function OMDefaultsTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
        props.omDefaultsFormLookupsLoad(formRefs);
    });
  const handleFieldChange = useCallback((name, value) => {
    });
    const handleSelectionChange = useCallback((name, e) => {
        if(e.selectedItem)
           props.oMDefaultsSelectionChanged(formRefs,name,e.selectedItem?.id,e.selectedItem?.name,e.selectedItem?.description,e.selectedItem?.chargeuom===undefined?0:1)
    }, []);
    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='E021AABA-D20E-419D-B1DA-D8780957DA6D'
            layoutName='OMDefaultForm'
            defaultFormSchema={OMDefaultsLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OMDefaultsTab);